module.exports = __webpack_public_path__ + "img/Slide007.859b55d2.jpg";